export const LIB_VERSION = '16.0.3'; // autogenerated 
//# sourceMappingURL=version.js.map